type WaitForTourTargetOptions = Readonly<{
    attempts: number
    intervalMs: number
}>

export function waitForTourTarget(selector: string, options?: WaitForTourTargetOptions): Promise<boolean> {
    const attempts = options?.attempts ?? 20
    const intervalMs = options?.intervalMs ?? 50

    return new Promise<boolean>((resolve) => {
        let tries = 0
        const tick = () => {
            tries += 1
            if (document.querySelector(selector)) {
                resolve(true)
                return
            }
            if (tries >= attempts) {
                resolve(false)
                return
            }
            window.setTimeout(tick, intervalMs)
        }
        tick()
    })
}

export function closeOpenOverlay(): void {
    const backdrop = Array.from(document.querySelectorAll(".MuiBackdrop-root")).at(-1)
    if (backdrop instanceof HTMLElement) backdrop.click()

    const esc = new KeyboardEvent("keydown", {
        key: "Escape",
        code: "Escape",
        keyCode: 27,
        which: 27,
        bubbles: true,
    })

    document.dispatchEvent(esc)
    window.dispatchEvent(esc)
}

export function clickTourTarget(selector: string): void {
    const element = document.querySelector(selector)
    if (element instanceof HTMLElement) element.click()
}

